import { createFileRoute } from '@tanstack/react-router';
import { ConnectInstagram } from '@/pages';

export const Route = createFileRoute('/_authenticated/settings/connect/')({
  component: ConnectInstagram,
});
